import { Activity } from "lucide-react";

const ACTION_LABEL = {
  approve_verification: "approved a photographer verification",
  reject_verification: "rejected a photographer verification",
  activate_user: "reactivated a user account",
  deactivate_user: "deactivated a user account",
  cancel_session: "cancelled a session",
  delete_review: "removed a review",
};

const timeAgo = (iso) => {
  const diffMs = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
};

export const RecentActivityFeed = ({ logs }) => {
  if (logs.length === 0) {
    return <p className="font-medium text-midnight-black/60" data-testid="no-recent-activity">No administrative activity yet.</p>;
  }

  return (
    <div className="border border-soft-gray rounded-2xl divide-y divide-soft-gray" data-testid="recent-activity-list">
      {logs.map((log, i) => (
        <div key={i} className="flex items-center gap-3 p-4" data-testid={`recent-activity-item-${i}`}>
          <Activity className="w-4 h-4 text-stranger-orange shrink-0" />
          <p className="text-sm font-medium flex-1">
            <span className="font-bold">{log.admin_name || "An admin"}</span> {ACTION_LABEL[log.action] || log.action}
          </p>
          <span className="text-xs font-bold text-midnight-black/40 whitespace-nowrap">{timeAgo(log.created_at)}</span>
        </div>
      ))}
    </div>
  );
};
